export default __webpack_public_path__ + "static/media/ec1a1a3a3a298a0d69e6f6f6c76686861581611456928.3c8ff8fd.webp";